<template>
  <div>
    <b-tooltip
      :target="tooltipUniqueId"
      triggers="hover"
      variant="primary"
    >
      {{ tooltipText }}
    </b-tooltip>
    <feather-icon
      :id="tooltipUniqueId"
      icon="InfoIcon"
      size="12"
      :style="`position:absolute; top:3; left:${left};`"
      class="text-primary"
    />
  </div>
</template>

<script>
import {
  BTooltip,
} from 'bootstrap-vue'

export default {
  name: 'BInputLabelInfo',
  components: {
    BTooltip,
  },
  props: {
    left: {
      type: Number,
      default: 0,
    },
    tooltipText: {
      type: String,
      default: 'Tooltip',
    },
    tooltipUniqueId: {
      type: String,
      required: true,
    },
  },
}
</script>
